// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Category$Showside from "./Category.bs.js";
import * as BasicTypes$Showside from "./BasicTypes.bs.js";
function getListPageContentType(parentCategory, activeCategory, indexCategory, relatedProductsId, route, isForcingPLP, param) {
  var listPageLayout;
  var exit = 0;
  if (typeof route === "number") {
    exit = 1;
  } else {
    switch (route.TAG | 0) {
      case /* Home */0:
        listPageLayout = parentCategory.listPageActiveLayout;
        break;
      case /* ListPage */1:
        listPageLayout = Belt_Option.mapWithDefault(activeCategory, parentCategory.listPageActiveLayout, function (category) {
          return category.listPageActiveLayout;
        });
        break;
      default:
        exit = 1;
    }
  }
  if (exit === 1) {
    listPageLayout = {
      TAG: /* SubCategoriesGrid */2,
      _0: {
        columns: /* TwoColumnGrid */1,
        gap: BasicTypes$Showside.emptyGridPayload.gap,
        maxRows: BasicTypes$Showside.emptyGridPayload.maxRows,
        maxWidth: BasicTypes$Showside.emptyGridPayload.maxWidth,
        padding: BasicTypes$Showside.emptyGridPayload.padding,
        pattern: BasicTypes$Showside.emptyGridPayload.pattern
      }
    };
  }
  var exit$1 = 0;
  var exit$2 = 0;
  if (typeof route === "number") {
    return /* EmptyListing */4;
  }
  switch (route.TAG | 0) {
    case /* Home */0:
      var match = route._0.homeType;
      if (typeof match === "number") {
        switch (match) {
          case /* Index */0:
            exit$2 = 3;
            break;
          case /* Favorites */1:
            return /* FavoriteProducts */1;
          case /* History */2:
            return /* HistoryProducts */0;
          case /* StoreCart */3:
            return /* StoreCartProducts */2;
        }
      } else {
        var match$1 = match._0;
        return {
          TAG: /* StoreCategoryProducts */10,
          categoryId: match$1.categoryId,
          sourceNodeId: match$1.sourceNodeId
        };
      }
      break;
    case /* ListPage */1:
      var match$2 = route._0.listPageType;
      if (typeof match$2 === "number") {
        switch (match$2) {
          case /* Favorites */0:
            return /* FavoriteProducts */1;
          case /* History */1:
            return /* HistoryProducts */0;
          case /* StoreCart */2:
            return /* StoreCartProducts */2;
        }
      } else {
        switch (match$2.TAG | 0) {
          case /* Category */0:
          case /* Product */1:
            exit$2 = 3;
            break;
          case /* StoreCategory */2:
            var match$3 = match$2._0;
            return {
              TAG: /* StoreCategoryProducts */10,
              categoryId: match$3.categoryId,
              sourceNodeId: match$3.sourceNodeId
            };
        }
      }
      break;
    case /* PDP */2:
    case /* QuickView */3:
      exit$2 = 3;
      break;
  }
  if (exit$2 === 3) {
    if (activeCategory !== undefined) {
      var exit$3 = 0;
      if (typeof route === "number" || route.TAG !== /* ListPage */1) {
        exit$3 = 4;
      } else {
        if (isForcingPLP || Belt_Option.isSome(route._0.filters)) {
          return {
            TAG: /* CLPWithFilters */6,
            _0: activeCategory
          };
        }
        if (typeof listPageLayout === "number") {
          return /* UnknownListing */3;
        }
        switch (listPageLayout.TAG | 0) {
          case /* SubCategoriesSlider */0:
            return {
              TAG: /* CLPSlider */4,
              _0: activeCategory
            };
          case /* SubCategoriesSliderWithHeader */1:
            return {
              TAG: /* CLPWithHeader */5,
              _0: Category$Showside.setTabbedSubCategories(activeCategory, undefined),
              _1: listPageLayout._0
            };
          case /* SubCategoriesGrid */2:
            return {
              TAG: /* CLPGrid */3,
              _0: activeCategory,
              _1: listPageLayout._0
            };
          case /* ProductGrid */3:
          case /* ProductSlider */4:
            exit$3 = 4;
            break;
        }
      }
      if (exit$3 === 4) {
        if (typeof listPageLayout === "number") {
          return /* UnknownListing */3;
        }
        switch (listPageLayout.TAG | 0) {
          case /* ProductGrid */3:
            return {
              TAG: /* PLPGrid */7,
              _0: activeCategory,
              _1: listPageLayout._0
            };
          case /* ProductSlider */4:
            return {
              TAG: /* PLPSlider */8,
              _0: activeCategory,
              _1: listPageLayout._0
            };
          default:
        }
      }
    } else if (indexCategory !== undefined && !(typeof route === "number" || route.TAG !== /* Home */0)) {
      if (isForcingPLP || Belt_Option.isSome(route._0.filters)) {
        return {
          TAG: /* IndexWithFilters */2,
          _0: indexCategory
        };
      }
      exit$1 = 2;
    } else {
      exit$1 = 2;
    }
  }
  if (exit$1 === 2 && relatedProductsId !== undefined) {
    return {
      TAG: /* RelatedProducts */9,
      productId: relatedProductsId
    };
  }
  if (typeof route === "number") {
    return /* UnknownListing */3;
  }
  if (route.TAG !== /* Home */0) {
    return /* UnknownListing */3;
  }
  if (typeof listPageLayout === "number") {
    return /* UnknownListing */3;
  }
  switch (listPageLayout.TAG | 0) {
    case /* SubCategoriesSlider */0:
    case /* SubCategoriesSliderWithHeader */1:
      return {
        TAG: /* IndexSlider */0,
        _0: listPageLayout._0
      };
    case /* SubCategoriesGrid */2:
      return {
        TAG: /* IndexGrid */1,
        _0: listPageLayout._0
      };
    default:
      return /* UnknownListing */3;
  }
}
export { getListPageContentType };
/* Category-Showside Not a pure module */